import React from 'react'
import { NotificationView } from './NotificationView'
import { useNotification } from './useNotification'

export const Notification = (): JSX.Element => {
  return (<NotificationView {...useNotification()} />)
}
